import * as React from 'react';

const Return = ({ ...props }) => (
    <svg
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.86243 11.5005L2.86243 17L2 11.5005V11.4995L2.86244 6L2.86243 11.5005ZM4.33944 11.5005L4.33944 17L2.86243 11.5005L4.33944 6L4.33944 11.5005ZM4.33944 11.5005L7.29716 6L7.29716 17L4.33944 11.5005ZM7.29716 11.5005L13 6L13 17L7.29716 11.5005Z"
            fill="currentColor"
        />
    </svg>
);

export default Return;
